import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supplier-dashboard',
  templateUrl: './supplier-dashboard.component.html',
  styles: [
  ]
})
export class SupplierDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
